export const roleData = {
  PROJECT_MANAGER:'项目管理员',
  PROJECT_DATA:'数据管理员',
  PROJECT_CHECK:'数据审核员',
  PROJECT_CENTER:'中心管理员',
  PROJECT_GATHER:'采集员（科研人员）',
}